export const PHONE_E164 = "+16787699652";
export const PHONE_DISPLAY = "(678) 769-9652";
export const PHONE_HREF = `tel:${PHONE_E164}`;
export const PUBLIC_SITE_URL = "https://gfysdesigns.com";
export const FB_USERNAME = process.env.REACT_APP_FB_PAGE_USERNAME || "gardenfountains.yardsculptures";
export const MESSENGER_URL = `https://m.me/${FB_USERNAME}`;

export const isIOS = () =>
  typeof navigator !== "undefined" &&
  (/iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1));

// iOS wants "sms:number&body=", Android and most others want "sms:number?body=".
export const smsHref = (body, ios = false) => {
  if (!body) return `sms:${PHONE_E164}`;
  return `sms:${PHONE_E164}${ios ? "&" : "?"}body=${encodeURIComponent(body)}`;
};

export const SMS_DRAFTS = {
  product: (title, slug) =>
    `Hi Chris, I'm interested in the ${title} (${PUBLIC_SITE_URL}/piece/${slug}). Is it still available?`,
  service:
    "Hi Chris, I need help with a fountain (installation, repair, or cleaning). I can send photos of the fountain and where it will go. My town is: ",
  majestic: (summary) =>
    `Hi Chris, I'm interested in a Majestic: ${summary}. Can we talk about it?`,
  custom: "Hi Chris, I'd like to talk about a custom fountain or garden piece. ",
  installation:
    "Hi Chris, I bought a fountain elsewhere and would like to talk about installation. I can send photos of the fountain and the space where I'd like it installed. My town is: ",
  general: "Hi Chris, I was on gfysdesigns.com and have a question about ",
};
